<template>
    <div class="module"
         style="position: relative;">
        <helpinfo :helpData="helpData" />
        <envSelect @envId="envClick"></envSelect>
        <div class="module-container"
             style="margin-top:-17px;">
            <input ref="copyrelay"
                   v-model="copyId"
                   class="copy-el" />
            <rcTable ref="rcTable"
                     :tableAttr="tableAttr">
                <Button slot="tootipL"
                        @click="refresh">
                    <i class="icon-refresh-o-2"></i>
                </Button>
                <Button type="primary"
                        @click="addSecgFun()"
                        :disabled="!hasPermission('CB090402')"
                        slot="tootipL">
                    <i class="icon-plus-o-1"></i><span>{{$t('创建')}}</span>
                </Button>
                <!-- <Dropdown trigger="click"
                          :transfer="true"
                          placement="bottom-start"
                          slot="tootipL">
                    <Button type="primary"
                            :disabled="!hasPermission('CB090402')"
                            style="height:32px;">
                        <i class="icon-plus-o-1"></i>
                        <span style="padding:0 3px;">{{$t('创建')}}</span>
                        <Icon type="ios-arrow-down"></Icon>
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem :name="item.value"
                                      v-for="item in envList"
                                      :key="item.value">
                            <div @click="addSecgFun(item)">
                                <i :class="envIcon(item.type)"
                                   style="zoom: 0.65;margin-right:0;"></i>
                                {{item.name}}
                            </div>
                        </DropdownItem>
                        <div v-if="envList&&envList.length === 0"
                             class="env-no-data">
                            <i class="icon-prompt-1-o"></i>
                            {{$t('暂无数据')}}
                        </div>
                    </DropdownMenu>
                </Dropdown> -->
            </rcTable>
        </div>
        <Modal v-model="modalAdd"
               :title="formtype+$t('安全组')"
               class="securitygroup-form"
               :mask-closable="false"
               @on-cancel="handleReset('formSlblist')">
            <Form ref="formSlblist"
                  :model="formData"
                  class="slbist-addform"
                  :rules="rules"
                  :label-width="100">
                <!-- <FormItem :label="`${$t('云环境')}:`"
                          class="form-item"
                          v-if="envData.envName&&formtype==$t('创建')">
                    {{envData.envName}}
                </FormItem> -->
                <FormItem :label="`${$t('云环境')}:`"
                          prop="envId"
                          v-if="formtype===$t('创建')">
                    <Select style="width:90%"
                            filterable
                            @on-change="envChange"
                            v-model="formData.envId">
                        <Option v-for="(item, index) in envList"
                                :key="index"
                                :value="item.value">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <FormItem :label="`${$t('名称')}:`"
                          prop="name">
                    <Input v-model="formData.name"
                           style="width:90%"
                           :maxlength="envData.envType === 'Qcloud' ? 60 : envData.envType === 'ESCloud' ? 255 : ''"
                           :placeholder="$t('请输入名称')"
                           class="form-item" />
                    <Tooltip v-if="envData.envType === 'Aliyun'"
                             theme="light"
                             placement='right'
                             :transfer='true'>
                        <i class="icon-prompt-1-o tips-icon-prompt"></i>
                        <div slot="content">
                            <span>{{$t('长度为2-128个字符，不能以特殊字符及数字开头，只可包含特殊字符中的"."，"_"或"-"')}}</span>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem :label="`${$t('所属项目')}:`"
                          v-if="formtype===$t('创建')">
                    <Select style="width:90%"
                            v-model="formData.projectId">
                        <Option v-for="(item, index) in projectDataList"
                                :key="index"
                                :value="item.orgSid">{{item.orgName}}</Option>
                    </Select>
                </FormItem>
                <FormItem :label="`${$t('描述')}:`"
                          prop="description">
                    <Input v-model="formData.description"
                           style="width:90%"
                           type="textarea"
                           :autosize=" { minRows: 6, maxRows: 10 }"
                           :maxlength="envData.envType === 'Qcloud' ? 100 : 255"
                           class="form-item" />
                </FormItem>
                <!--之前的代码是阿里云可以编辑网络网络类型和私有网络，但是根据后端反馈应该无法编辑的，现将其屏蔽，后续有问题再修改-->
                <FormItem :label="`${$t('网络类型')}:`"
                          prop="netType"
                          class="form-item"
                          v-if="envData.envType=='Aliyun'&&formtype==$t('创建')">
                    <Select v-model="formData.netType"
                            style="width:90%">
                        <Option v-for="(item,i) in netTypes"
                                :value="item.typename"
                                :key="'netType'+i">{{item.typename}}</Option>
                    </Select>
                </FormItem>
                <FormItem :label="`${$t('私有网络')}:`"
                          prop="vpc"
                          class="form-item"
                          v-if="envData.envType=='Aliyun'&&formtype==$t('创建')">
                    <Select v-model="formData.vpc"
                            style="width:90%">
                        <Option :value="item.networkUuid"
                                v-for="(item,i) in vpcs"
                                :key="'vpc'+i">{{item.networkName}}</Option>
                    </Select>
                    <span style="position: absolute;right: 20px;top: 0px;"
                          v-if="hasPermission('CB090101')"
                          @click="createVpc"
                          class="rc-text-btn">
                        <i class="icon-add-to-o"></i>
                    </span>
                </FormItem>
            </Form>
            <div class="submit"
                 slot="footer">
                <Button @click="handleReset('formSlblist')"
                        type="text"
                        style="margin-left: 8px">{{$t('取消')}}</Button>
                <Button type="primary"
                        :loading="modalLoading"
                        @click="handleSubmit('formSlblist')">{{formtype === $t('创建') ? $t('创建') : $t('保存')}}</Button>

            </div>
        </Modal>
        <rules ref="envsecrules"
               :envType="envData.envType"
               :rulesData="rulesData"></rules>
    </div>
</template>
<script>
import helpinfo from '@c/basic/helpinfo'
import rcTable from '@c/basic/rcTable'
import envSelect from '@c/basic/env'
import API from '@/service/api.js'
import { notHttp } from '@/service/validator.js'
import rules from './components/rules.vue'
import dropdownlist from '@c/basic/dropdownlist'

export default {
    name: 'securitygroup',
    components: {
        helpinfo,
        rcTable,
        envSelect,
        rules
    },
    data () {
        const validSecName = (rule, value, callback) => {
            const expFailure = /^((http(s)?:\/\/)|\d|[._-])/
            let expSuc = /^[a-zA-Z\u4E00-\u9FA5][a-zA-z\u4E00-\u9FA5-_.\d]{1,127}$/
            if (this.envData.envType === 'ESCloud') {
                expSuc = /^[a-zA-Z\u4E00-\u9FA5][a-zA-z\u4E00-\u9FA5-_.\d]{0,254}$/
            }
            if (expFailure.test(value) && this.envData.envType !== 'Qcloud') {
                callback(new Error('不能以https://、https://、数字或者特殊字符开头'))
            } else if (!expSuc.test(value) && this.envData.envType !== 'Qcloud') {
                callback(new Error('安全组名称不合法'))
            } else {
                callback()
            }
        }
        return {
            copyId: null,
            helpData: {
                modelName: this.$t('安全组'),
                showBack: false
            },
            envList: [],
            envData: {
                envId: '',
                envName: '',
                envType: ''
            },
            noChange: true,
            rulesData: '',
            netTypes: [{ id: '1', typename: '专有网络' }],
            vpcs: [],
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.GET_SE_GROUPS, false),
                    params: {
                        projectId: this.$store.state.user.currentUser.projectId === 'all' ? '' : this.$store.state.user.currentUser.projectId,
                        envId: sessionStorage.getItem('resourcesEnvId') || null
                    }
                },
                isWebsoct: true,
                wsKey: 'id',
                searchColumns: [
                    {
                        key: 'nameLike',
                        title: this.$t('名称'),
                        searchDefaultValue: ''
                    }
                ],
                searchShow: true,
                tableSearchKey: 'allFloatingIpTable', // 当作查询保持的key存在
                searchDefaultValueList: [],
                // tableColKey: 'allFloatingIpTable',
                isMultiSelect: false,
                columnsChooseShow: true,
                referenceVal: 1310,
                columns: [
                    {
                        title: this.$t('名称') + '/ID',
                        key: 'id',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 200,
                        render: (h, params) => {
                            return h('div', {
                                class: 'ellipsis  resource',
                                style: { position: 'relative' }
                            }, [
                                h(
                                    'div',
                                    {
                                        class: 'ellipsis',
                                        style: { width: '170px', paddingTop: '5px', height: '50px' }
                                    },
                                    [
                                        h('div',
                                            {
                                                class: 'ellipsis name',
                                                style: {
                                                    cursor: this.hasPermission('CB090411') ? 'pointer' : '',
                                                    color: this.hasPermission('CB090411') ? '#1f68b3' : ''
                                                },
                                                attrs: {
                                                    title: params.row.name

                                                },
                                                on: {
                                                    click: () => {
                                                        this.hasPermission('CB090411') && this.rulesFun(params.row.securityGroupRules)
                                                    }
                                                }
                                            },
                                            params.row.name
                                        ),
                                        h(
                                            'div',
                                            {
                                                class: 'ellipsis',
                                                style: { width: '170px', color: '#666', paddingBottom: '5px' },
                                                attrs: {
                                                    title: params.row.uuid
                                                }
                                            },
                                            params.row.uuid
                                        ),
                                        h(
                                            'Tooltip',
                                            {
                                                class: 'rc-tips copyId',
                                                style: { position: 'absolute', left: '175px', top: '26px', width: '15px' },
                                                props: {
                                                    transfer: true,
                                                    placement: 'top',
                                                    theme: 'light',
                                                    content: this.$t('复制ID')
                                                }
                                            },
                                            [
                                                h('Icon', {
                                                    class: 'copy-icon',
                                                    style: { color: '#1f68b3', 'font-size': '14px' },
                                                    props: {
                                                        type: 'ios-browsers-outline'
                                                    },
                                                    on: {
                                                        click: () =>
                                                            this.copylink(
                                                                params.row.uuid
                                                            )
                                                    }
                                                })
                                            ]
                                        )
                                    ]
                                )
                            ])
                        }
                    },
                    {
                        title: this.$t('云环境'),
                        key: 'cloudEnvType',
                        sortable: true,
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 170,
                        render: (h, params) => {
                            return h('p', { attrs: { title: params.row.cloudEnvName }, class: { 'rc-ellipsis': true } }, [
                                h('i', { class: this.envIcon(params.row.cloudEnvType), style: 'margin-right: 0;' }),
                                h('span', { class: 'icon-text' }, !params.row.cloudEnvName ? this.$t('其他') : params.row.cloudEnvName)
                            ])
                        }
                    },
                    {
                        title: this.$t('网络'),
                        key: 'vpcName',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        resizable: true,
                        width: 100,
                        render: (h, params) => {
                            return h('div', { attrs: { title: params.row.cloudEnvName }, class: { 'rc-ellipsis': true } }, [
                                h('p', {
                                    style: {
                                        cursor: params.row.vpcName ? 'pointer' : '',
                                        color: params.row.vpcName ? '#1f68b3' : ''
                                    },
                                    on: {
                                        click: () =>
                                            params.row.vpcName && this.vpcFun(params.row)
                                    },
                                    attrs: { title: params.row.vpcName || '--' }
                                }, params.row.vpcName || '--'),
                                h('p', { attrs: { title: params.row.netType } }, params.row.netType)
                            ])
                        }
                    },
                    {
                        title: this.$t('规则数量'),
                        key: 'ruleCount',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        resizable: true,
                        width: 80,
                        align: 'center',
                        render: (h, params) => {
                            return h('div', {
                                style: {
                                    cursor: this.hasPermission('CB090411') ? 'pointer' : '',
                                    color: this.hasPermission('CB090411') ? '#1f68b3' : ''
                                },
                                on: {
                                    click: () =>
                                        this.hasPermission('CB090411') && this.setrulesFun(params.row)
                                }
                            }, params.row.ruleCount)
                        }
                    },
                    {
                        title: this.$t('关联实例'),
                        key: 'instanceCoun',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        resizable: true,
                        width: 100,
                        align: 'center',
                        render: (h, params) => {
                            return h('div', {
                                style: {
                                    cursor: this.hasPermission('CB090410') ? 'pointer' : '',
                                    color: this.hasPermission('CB090410') ? '#1f68b3' : ''
                                },
                                on: {
                                    click: () =>
                                        this.hasPermission('CB090410') && this.instanceFun(params.row)
                                }
                            }, params.row.instanceCoun)
                        }
                    },
                    // {
                    //     title: this.$t('所属组织'),
                    //     key: 'ownerOrgName',
                    //     columnShow: true,
                    //     columnsChoosed: true,
                    //     className: 'ellipsis',
                    //     disabledSearch: true,
                    //     resizable: true,
                    //     width: 140,
                    //     render: (h, params) => {
                    //         let ownerOrgName = ''
                    //         if (this.envData.envType === 'Aliyun') {
                    //             ownerOrgName = params.row.originOrgName ? params.row.originOrgName : '--'
                    //         } else {
                    //             ownerOrgName = params.row.ownerOrgName ? params.row.ownerOrgName : '--'
                    //         }
                    //         return h('span', {
                    //             class: 'rc-ellipsis',
                    //             attrs: {
                    //                 title: ownerOrgName
                    //             }
                    //         }, ownerOrgName)
                    //     }
                    // },
                    // {
                    //     title: this.$t('所属专有网络'),
                    //     key: 'vpc',
                    //     className: 'ellipsis',
                    //     columnShow: true,
                    //     disabledSearch: true,
                    //     columnsChoosed: true,
                    //     resizable: true,
                    //     width: 120,
                    //     excludeEnvs: ['OpenStack', 'OpenStack-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS', 'Nine9Cloud', 'Nine9Cloud-Admin', 'HuaweiCloud', 'Qcloud'],
                    //     render: (h, params) => {
                    //         return h('span', { attrs: { title: params.row.vpcName } }, params.row.vpcName)
                    //     }
                    // },
                    {
                        title: this.$t('项目'),
                        key: 'orgName',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        resizable: true,
                        width: 120,
                        render: (h, params) => {
                            return h('div', {
                                attrs: {
                                    title: params.row.orgName
                                }
                            }, params.row.orgName)
                        }
                    },
                    {
                        title: this.$t('描述'),
                        key: 'description',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        resizable: true,
                        minWidth: 120,
                        excludeEnvs: ['PowerVC'],
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.description } }, params.row.description)
                        }
                    },
                    {
                        title: this.$t('操作'),
                        width: 190,
                        // excludeEnvs: ['Azure'],
                        fixed: 'right',
                        render: (h, params) => {
                            const link = []
                            link.push(h(dropdownlist, {
                                props: {
                                    operateConfig: this.configBtn(params.row)
                                },
                                style: 'cursor:pointer;display:inline-block;margin-left: 5px;',
                                on: { event: (type) => { this.operate(type, params.row) } }
                            }))
                            let arr = [
                                h('a', { class: { 'disabled-per': !this.hasPermission('CB090411') || params.row.mode === 'share' }, on: { click: () => this.hasPermission('CB090411') && params.row.mode !== 'share' && this.setrulesFun(params.row) } }, this.$t('配置规则')),
                                h('a', { class: { 'disabled-per': !this.hasPermission('CB090410') }, on: { click: () => this.hasPermission('CB090410') && this.instanceFun(params.row) } }, this.$t('管理实例'))
                            ]
                            if (this.envData.envType !== 'Aws') {
                                arr = arr.concat([
                                    h('div', {
                                        style: { display: 'inline-block' },
                                        class: 'tbl-btn-div'
                                    }, link)
                                ])
                            }
                            return h('div', {
                                class: 'tbl-btn-div'
                            }, arr)
                        }
                    }
                ]
            },

            modalAdd: false,
            projectDataList: [],
            formData: {
                envId: '',
                envName: '',
                envType: '',
                id: '',
                name: '',
                projectId: '',
                description: '',
                netType: '', // 网络类型
                vpc: '' // 专有网络id
            },
            formtype: '',
            rules: {
                name: [
                    { required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'blur' },
                    { min: 2, max: 128, message: this.$t('长度2-128位'), trigger: 'blur' },
                    { validator: validSecName, trigger: 'blur' }
                ],
                vpc: [
                    { required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'change' }
                ],
                description: [
                    { min: 2, max: 256, message: this.$t('长度2-256位'), trigger: 'blur' },
                    { validator: notHttp, trigger: 'blur' }
                ],
                envId: [
                    { required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'change' }
                ],
                netType: [
                    { required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'change' }
                ]
            },
            modalLoading: false
        }
    },
    created () {
        this.getProject()// 查询项目下拉列表
        if (sessionStorage.getItem('resourcesEnv')) {
            this.envData = sessionStorage.getItem('resourcesEnv')
        }
        // if (this.isBssAdmin) {
        //     this.tableAttr.columns.splice(this.tableAttr.columns.length - 1, 1)
        // }
    },
    methods: {
        vpcFun (row) {
            this.$router.push({
                path: '/mgt/vpc',
                query: {
                    id: row.id,
                    vpcName: row.vpcName
                }
            })
        },
        // 查询项目
        getProject (templateId) {
            this.axios.get(this.urlFormat(API.GET_ACCESS_POLICES_ID_PROJECT, false, [this.$store.state.user.currentUser.info.userSid])).then(res => {
                if (res) {
                    this.projectDataList = res
                    if (this.projectDataList.length > 0) {
                        this.formData.projectId = this.projectDataList[0].orgSid
                    }
                }
            })
        },
        // 复制剪切板
        copylink (id) {
            this.copyId = id
            this.$nextTick(() => {
                const copyrelay = this.$refs.copyrelay
                copyrelay.select()
                document.execCommand('Copy')
                this.$Message.success(this.$t('ID复制成功'))
            })
        },
        // 生成更多按钮
        configBtn: function (obj) {
            const btnConfig = [
                { value: 'clone', btnName: this.$t('克隆'), display: true, disabled: !this.hasPermission('CB090405') },
                { value: 'edit', btnName: this.$t('编辑'), display: true, disabled: !this.hasPermission('CB090403') },
                { value: 'delete', btnName: this.$t('删除'), display: true, disabled: !this.hasPermission('CB090404') }
            ]
            return JSON.stringify(btnConfig)
        },
        getEnvs () {
            // TODO 查询条件 云环境过滤
            this.envList = []
            this.axios.get(this.urlFormat(API.GET_ENVS, true)).then(res => {
                if (res && res.length) {
                    res.forEach(item => {
                        this.envList.push({
                            type: item.cloudEnvType,
                            value: item.id + '',
                            name: item.cloudEnvName
                        })
                    })
                    this.envData.envId = this.envList[0].value
                    this.envData.envType = this.envList[0].type
                    this.envData.envName = this.envList[0].name
                }
            })
        },
        // 更多按钮事件分发
        operate: function (operateType, row) {
            this.envData = {
                envId: row.cloudEnvId,
                envType: row.cloudEnvType,
                envName: row.cloudEnvName
            }
            switch (operateType) {
                case 'clone':
                    this.cloneFun(row)
                    break
                case 'delete':
                    this.deleteFun(row)
                    break
                case 'edit':
                    this.editFun(row)
                    break
            }
        },
        // 单个删除
        deleteFun (obj) {
            // if (!this.hasPermission('CB090404') || (this.envData.envType !== 'Aliyun' && obj.name === 'default') || obj.mode === 'share') return
            if (!this.hasPermission('CB090404')) return
            this.$Modal.confirm({
                okText: this.$t('确定'),
                cancelText: this.$t('取消'),
                title: this.$t('删除'),
                content: this.$t('确认要删除该安全组吗?'),
                onOk: () => {
                    this.axios.delete(this.urlFormat(API.DELETE_SG, true, [obj.id])).then(res => {
                        this.refresh()
                    })
                }
            })
        },
        // 获取form表单对应云环境参数
        getFormP () {
            if (this.envData.envType === 'Aliyun') {
                this.getVpcs({ envId: this.envData.envId })
            }
        },
        // 点击创建
        addSecgFun (item) {
            this.getEnvs()
            this.getProject()// 查询项目下拉列表
            if (!this.hasPermission('CB090402')) return
            this.modalAdd = true
            this.formtype = this.$t('创建')
            // this.envData.envId = item.value
            // this.envData.envType = item.type
            // this.envData.envName = item.name
        },
        envChange () {
            this.envData = {
                envId: '',
                envType: '',
                envName: ''
            }
            this.envList.forEach(item => {
                if (Number(item.value) === Number(this.formData.envId)) {
                    this.envData.envId = item.value
                    this.envData.envType = item.type
                    this.envData.envName = item.name
                    this.$nextTick(() => {
                        this.getFormP()
                        if (this.envData.envType === 'ESCloud') {
                            this.rules.name[1] = { min: 1, max: 255, message: this.$t('长度1-255位'), trigger: 'blur' }
                        }
                    })
                }
            })
        },
        // 点击编辑
        editFun (obj) {
            if (!this.hasPermission('CB090403')) return
            this.modalAdd = true
            this.formtype = this.$t('编辑')
            this.formData.envId = obj.cloudEnvId
            this.formData.id = obj.id
            this.formData.name = obj.name
            this.formData.projectId = obj.orgSid
            this.formData.description = obj.description
            this.formData.netType = obj.netType
            this.formData.vpc = obj.vpc
            this.getFormP()
            if (this.envData.envType === 'ESCloud') {
                this.rules.name[1] = { min: 1, max: 255, message: this.$t('长度1-255位'), trigger: 'blur' }
            }
        },
        // 点击克隆
        cloneFun (obj) {
            if (!this.hasPermission('CB090405')) return
            this.modalAdd = true
            this.formtype = this.$t('克隆')
            this.formData.envId = obj.cloudEnvId
            this.formData.id = obj.id
            this.formData.name = obj.name
            this.formData.projectId = obj.orgSid
            this.formData.description = obj.description
            this.formData.netType = obj.netType
            this.formData.vpc = obj.vpc
            this.getFormP()
        },
        // 查看安全组规则
        rulesFun (obj) {
            this.rulesData = []
            if (!this.hasPermission('CB090411')) return
            this.rulesData = JSON.parse(obj)
            // const data = []
            // this.rulesData = data
            this.$refs.envsecrules.openModal()
        },
        // 查看实例
        instanceFun (obj) {
            if (!this.hasPermission('CB090410')) return
            const query = {
                envId: obj.cloudEnvId,
                envType: obj.cloudEnvType,
                envName: obj.cloudEnvName,
                id: obj.id,
                securityid: obj.uuid,
                name: obj.name,
                vpcId: obj.vpcId
            }
            if (this.envData.envType === 'Aws' || this.envData.envType === 'Aliyun') {
                query.vpcId = obj.vpcId
            }
            this.$router.push({
                path: `/mgt/security_group/instance/${obj.id}`,
                query: query
            })
        },
        // 点击配置规则
        setrulesFun (obj) {
            if (!this.hasPermission('CB090411')) return
            this.$router.push({
                path: `/mgt/security_group/rule/${obj.id}`,
                query: {
                    envId: obj.cloudEnvId,
                    envType: obj.cloudEnvType,
                    envName: obj.cloudEnvName,
                    id: obj.id,
                    securityId: obj.id,
                    securityName: obj.name,
                    vpc: obj.vpcId
                }
            })
        },
        // 表单提交
        handleSubmit (name) {
            this.modalLoading = true
            this.$refs[name].validate((valid) => {
                if (valid) {
                    if (this.formtype === this.$t('创建')) {
                        const p = {
                            name: this.formData.name,
                            description: this.formData.description,
                            projectId: this.formData.projectId,
                            region: this.envData.envType === 'Qcloud' ? this.$route.query.region : '',
                            cloudEnvId: this.envData.envId,
                            vpc: this.formData.vpc, // 专有网络id,
                            netType: this.formData.netType// 网络类型
                        }
                        this.axios.post(this.urlFormat(API.GET_SE_GROUPS, false), p, {
                            timeout: 60000
                        }).then(res => {
                            if (res.status) {
                                setTimeout(() => {
                                    this.refresh()
                                    this.handleReset(name)
                                    this.modalLoading = false
                                    // 立即添加规则？跳转路由
                                    this.$Modal.confirm({
                                        okText: this.$t('确定'),
                                        cancelText: this.$t('取消'),
                                        title: this.$t('立即添加规则'),
                                        content: this.$t('创建成功，请立即创建安全组规则，以便能正常访问该安全组关联的实例。'),
                                        onOk: () => {
                                            this.$router.push({
                                                path: `/mgt/security_group/rule/${res.data.id}`,
                                                query: {
                                                    envType: res.data.cloudEnvType,
                                                    envName: res.data.cloudEnvName,
                                                    envId: res.data.cloudEnvId,
                                                    securityName: res.data.name,
                                                    id: res.data.id,
                                                    securityId: res.data.id,
                                                    vpc: res.data.vpcId
                                                }
                                            })
                                        }
                                    })
                                }, 500)
                            } else {
                                this.modalLoading = false
                            }
                        }).catch(e => {
                            this.modalLoading = false
                        })
                    } else if (this.formtype === this.$t('编辑')) {
                        this.axios.put(this.urlFormat(API.GET_SE_GROUPS, false), this.formData).then(res => {
                            if (res.status) {
                                this.refresh()
                                this.handleReset(name)
                                this.modalLoading = false
                            } else {
                                this.modalLoading = false
                            }
                        }).catch(e => {
                            this.modalLoading = false
                        })
                    } else if (this.formtype === this.$t('克隆')) {
                        const p = Object.assign({
                            cloudEnvId: this.envData.envId,
                            vpc: '', // 专有网络id,
                            netType: ''// 网络类型
                        }, this.formData)
                        this.axios.post(this.urlFormat(API.CLONE_SECURITY_GROUP, true), p).then(res => {
                            if (res.status) {
                                this.refresh()
                                this.handleReset(name)
                                this.modalLoading = false
                            } else {
                                this.modalLoading = false
                            }
                        }).catch(e => {
                            this.modalLoading = false
                        })
                    }
                } else {
                    this.modalLoading = false
                }
            })
        },
        // 清空表单并退出
        handleReset (name) {
            this.$refs[name].resetFields()
            this.modalAdd = false
            this.rules.name[1] = { min: 2, max: 128, message: this.$t('长度2-128位'), trigger: 'blur' }
        },
        // 获取私有网络
        getVpcs (params) {
            this.axios({
                methods: 'get',
                url: this.urlFormat(API.GET_NETWORKSBYPARAMS, true),
                params: params
            }).then(res => {
                this.vpcs = res.networks
            })
        },
        // 创建vpc
        createVpc () {
            this.$router.push({
                path: '/mgt/vpc',
                query: {
                    envId: this.envData.envId,
                    envType: this.envData.envType,
                    envName: this.envData.envName,
                    region: this.$route.query.region,
                    create: true
                }
            })
        },
        // 云环境过滤
        envClick (data) {
            this.tableAttr.source.params.envId = data
            this.$refs.rcTable && this.$refs.rcTable.refreshTable()
        },
        refresh () { // 刷新
            this.$refs.rcTable.refreshTable()
        }
    },
    watch: {
        // 如果路由有变化，会执行该方法
        '$route' (newNal, oldval) {
            if (!newNal.query.create && oldval.query.create) return
            this.fetchDate()
        },
        'formData.name' (val) {
            if (this.envData.envType === 'Qcloud') {
                this.rules.name.splice(1, 1)
            }
        }
    }
}
</script>
<style lang="less" scoped>
.copy-el {
    opacity: 0;
    height: 1px;
    overflow: hidden;
    margin: 0;
    padding: 0;
}
</style>
<style lang="less">
.newRcTable .rcTable-content .ellipsis > div.copyId {
    opacity: 0;
}
.newRcTable .rcTable-content .ellipsis > div {
    .copyId {
        opacity: 0;
    }
}
.newRcTable .rcTable-content .ellipsis > div:hover {
    .copyId {
        opacity: 1;
    }
}
.newRcTable .rcTable-content .ellipsis > div {
    .name {
        line-height: 22px;
    }
    .copyId {
        line-height: 22px;
    }
}
.renew-content .ivu-spin-text {
    display: block !important;
    margin-left: -12px;
    margin-top: 5px;
}
</style>
